(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {

    function initSearchListeners() {
      const searchInput = document.getElementById('collection-search');
      if (!searchInput || searchInput._initialized) return;
      searchInput._initialized = true;

      const clearBtn = document.getElementById('collection-search-clear');

      searchInput.addEventListener('input', function () {
        const query = this.value.toLowerCase().trim();
        const items = document.querySelectorAll('.product-grid__item');

        if (clearBtn) {
          clearBtn.classList.toggle('visible', this.value.length > 0);
        }

        items.forEach(function (item) {
          const titleEl = item.querySelector('[class*="product-card__title"], [class*="card__title"], h2, h3');
          const vendorEl = item.querySelector('rte-formatter');
          const title = titleEl ? titleEl.textContent.toLowerCase() : '';
          const vendor = vendorEl ? vendorEl.textContent.toLowerCase() : '';
          item.style.display = (title.includes(query) || vendor.includes(query)) ? '' : 'none';
        });

        const visibleItems = Array.from(items).filter(function (item) {
          return item.style.display !== 'none';
        });

        if (visibleItems.length === 0 && query.length > 0) {
          let emptyState = document.getElementById('collection-search-empty');
          if (!emptyState) {
            emptyState = document.createElement('div');
            emptyState.id = 'collection-search-empty';
            emptyState.innerHTML = '<p class="collection-search-empty__title">Geen producten gevonden.</p><p class="collection-search-empty__sub">Probeer een andere zoekterm.</p>';
            const grid = document.querySelector('.product-grid');
            if (grid) grid.parentNode.insertBefore(emptyState, grid.nextSibling);
          }
          emptyState.style.display = '';
        } else {
          const emptyState = document.getElementById('collection-search-empty');
          if (emptyState) emptyState.style.display = 'none';
        }
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input'));
          searchInput.blur();
          clearBtn.classList.remove('visible');
        });
      }

      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input'));
          searchInput.blur();
          if (clearBtn) clearBtn.classList.remove('visible');
        }
      });
    }

    function appendSearchToFacets() {
      const facetsBar = document.querySelector('.facets--horizontal') || document.querySelector('.facets-toggle') || document.querySelector('.facets');
      if (!facetsBar) return;

      const allWrappers = document.querySelectorAll('.collection-search-wrapper');
      if (allWrappers.length > 1) {
        for (let i = 1; i < allWrappers.length; i++) {
          allWrappers[i].remove();
        }
      }

      const searchWrapper = allWrappers[0];
      if (searchWrapper && !facetsBar.contains(searchWrapper)) {
        observer.disconnect();
        facetsBar.appendChild(searchWrapper);
        observer.observe(document.body, { childList: true, subtree: true });
      }

      initSearchListeners();
    }

    const observer = new MutationObserver(function () {
      appendSearchToFacets();
    });

    appendSearchToFacets();
    observer.observe(document.body, { childList: true, subtree: true });

    const searchWrapper = document.querySelector('.collection-search-wrapper');
    if (searchWrapper) {
      searchWrapper.addEventListener('click', function () {
        document.getElementById('collection-search').focus();
      });
    }

    initSearchListeners();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-hero"] && !Shopify.designMode) return;
  try {
    
// ——— DRAWER — altijd beschikbaar, onafhankelijk van status-logica ———
(function () {
  var dialog     = document.getElementById('wl-uren-dialog');
  var triggerBtn = document.getElementById('wl-uren-btn');
  var sluitBtn   = document.getElementById('wl-drawer-sluiten');
  var statusEl   = document.getElementById('wl-status-tekst');

  if (!dialog || !triggerBtn || !statusEl) return;

  // ——— HELPER FUNCTIES ———
  function datumSleutel(d) {
    return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  }
  function tMin(t) { var d = t.split(':'); return +d[0]*60 + +d[1]; }
  function fmtOpen(t)  { var d = t.split(':'); return d[1]==='00' ? d[0] : t; }
  function fmtSluit(t) { var d = t.split(':'); return d[1]==='00' ? d[0]+'u' : t; }
  function fmtB(o,s)   { return fmtOpen(o)+'\u2013'+fmtSluit(s); }

  function paasZondag(jaar) {
    var a=jaar%19,b=Math.floor(jaar/100),c=jaar%100,d=Math.floor(b/4),e=b%4,
        f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,
        i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),
        mnd=Math.floor((h+l-7*m+114)/31),dag=((h+l-7*m+114)%31)+1;
    return new Date(jaar, mnd-1, dag);
  }
  function plusDagen(d,n) { var r=new Date(d); r.setDate(r.getDate()+n); return r; }

  function bouwFeestdagen(jaar) {
    var paas=paasZondag(jaar), map={};
    map[jaar+'-01-01']                        = {gesloten:true, naam:'Nieuwjaarsdag'};
    map[datumSleutel(plusDagen(paas,1))]      = {gesloten:true, naam:'Tweede Paasdag'};
    map[datumSleutel(plusDagen(paas,39))]     = {gesloten:true, naam:'Hemelvaartsdag'};
    map[datumSleutel(plusDagen(paas,49))]     = {gesloten:true, naam:'Tweede Pinksterdag'};
    map[jaar+'-12-24']                        = {sluitUiterlijk:'19:00', naam:'Kerstavond'};
    map[jaar+'-12-25']                        = {gesloten:true, naam:'Eerste Kerstdag'};
    map[jaar+'-12-26']                        = {gesloten:true, naam:'Tweede Kerstdag'};
    return map;
  }

  function effectieveInfo(uitzon, feestd, datumStr, basisInfo) {
    var u = uitzon[datumStr] || feestd[datumStr];
    if (!u) return basisInfo;
    if (u.gesloten) return null;
    if (u.sluitUiterlijk && basisInfo && basisInfo.open) {
      var e = Object.assign({}, basisInfo);
      if (e.sluit > u.sluitUiterlijk) e.sluit = u.sluitUiterlijk;
      return e;
    }
    if (u.open) return {open: u.open, sluit: u.sluit};
    return basisInfo;
  }

  // ——— DRAWER BODY BOUWEN ———
  function bouwDrawerBody() {
    var body = document.getElementById('wl-drawer-body');
    if (!body) return;

    var schema, afhalenSchema;
    try { schema = JSON.parse(statusEl.dataset.schema); } catch(e) { return; }
    try {
      var ar = statusEl.dataset.afhalenSchema;
      afhalenSchema = (ar && ar !== 'null') ? JSON.parse(ar) : null;
    } catch(e) { afhalenSchema = null; }

    var effectiefAfhalen = afhalenSchema || schema;
    var nu = new Date(new Date().toLocaleString('en-US', {timeZone:'Europe/Amsterdam'}));
    var dag = nu.getDay().toString();
    var jaar = nu.getFullYear();
    var feestdagen = Object.assign({}, bouwFeestdagen(jaar), bouwFeestdagen(jaar+1));

    var uitzonderingen = {};
    try {
      var lijst = JSON.parse(statusEl.dataset.uitzonderingen || '[]');
      lijst.forEach(function(u) {
        if (u.van && u.tot) {
          var cur = new Date(u.van), einde = new Date(u.tot);
          while (cur <= einde) {
            uitzonderingen[datumSleutel(cur)] = u;
            cur.setDate(cur.getDate()+1);
          }
        } else if (u.datum) {
          uitzonderingen[u.datum] = u;
        }
      });
    } catch(e) {}

    var dagNamen = {'0':'Zondag','1':'Maandag','2':'Dinsdag','3':'Woensdag','4':'Donderdag','5':'Vrijdag','6':'Zaterdag'};
    var maandag = new Date(nu);
    maandag.setDate(nu.getDate() - ((nu.getDay()+6)%7));

    var html = '<div class="wl-uren-lijst">';
    for (var i=1; i<=7; i++) {
      var di   = (i%7).toString();
      var dDat = new Date(maandag);
      dDat.setDate(maandag.getDate() + (i===7 ? 6 : i-1));
      var dStr = datumSleutel(dDat);
      var winkelInfo  = effectieveInfo(uitzonderingen, feestdagen, dStr, schema[di]);
      var afhaalInfo  = effectieveInfo(uitzonderingen, feestdagen, dStr, effectiefAfhalen[di]);
      var isVandaag   = di === dag;
      var uitzon      = uitzonderingen[dStr] || feestdagen[dStr];
      var uitznaam    = uitzon && uitzon.naam ? uitzon.naam : null;

      html += '<div class="wl-uren-dag-rij'+(isVandaag?' wl-uren-dag-rij--vandaag':'')+'">';
      html += '<div><span class="wl-uren-dag">'+dagNamen[di]+'</span>';
      if (uitznaam) html += '<div class="wl-uren-feestdag">'+uitznaam+'</div>';
      html += '</div><div class="wl-uren-tijden">';

      var hwk = winkelInfo && winkelInfo.open;
      var haf = afhaalInfo && afhaalInfo.open;
      var zelfde = hwk && haf && winkelInfo.open===afhaalInfo.open && winkelInfo.sluit===afhaalInfo.sluit;

      if (!hwk && !haf) {
        html += '<span class="wl-uren-gesloten">Gesloten</span>';
      } else {
        if (hwk) html += '<div>'+fmtB(winkelInfo.open, winkelInfo.sluit)+'</div>';
        if (haf && !zelfde) {
          html += '<div class="wl-uren-tijden__afhalen">Afhalen op bestelling '+fmtB(afhaalInfo.open, afhaalInfo.sluit)+'</div>';
        } else if (hwk && !haf && afhalenSchema) {
          html += '<div class="wl-uren-geen-afhalen">In verband met drukte alleen winkelen mogelijk</div>';
        }
      }
      html += '</div></div>';
    }
    html += '</div>';

    // ——— UITLEGTEKST ———
    var heeftPickupOnly   = false;
    var heeftGeenAfhalen  = false;
    var heeftBeperktSlot  = false;

    // Herloop om scenario's te detecteren (op basis van al gebouwde data)
    for (var j = 1; j <= 7; j++) {
      var dj   = (j % 7).toString();
      var djDat = new Date(maandag); djDat.setDate(maandag.getDate() + (j === 7 ? 6 : j - 1));
      var djStr = datumSleutel(djDat);
      var wj = effectieveInfo(uitzonderingen, feestdagen, djStr, schema[dj]);
      var aj = effectieveInfo(uitzonderingen, feestdagen, djStr, effectiefAfhalen[dj]);
      var hwj = wj && wj.open;
      var haj = aj && aj.open;
      var zjl = hwj && haj && wj.open === aj.open && wj.sluit === aj.sluit;
      if (!hwj && haj)            heeftPickupOnly  = true;
      if (hwj && !haj && afhalenSchema) heeftGeenAfhalen = true;
      if (hwj && haj && !zjl)    heeftBeperktSlot = true;
    }

    var basisTekst = 'Bestellingen worden zo snel mogelijk verwerkt, uiterlijk binnen één werkdag. Je ontvangt een bevestigingsmail zodra je bestelling klaarligt. Die heb je nodig bij het afhalen.';
    var scenarioTekst = '';

    if (heeftPickupOnly) {
      scenarioTekst += 'De momenten gemarkeerd als \u2018Afhalen op bestelling\u2019 zijn uitsluitend voor het ophalen van vooraf geplaatste bestellingen. De winkel is op die momenten niet open voor regulier bezoek. ';
    }

    if (heeftGeenAfhalen && heeftBeperktSlot) {
      scenarioTekst += 'Op drukke dagen of momenten kan afhalen beperkt zijn tot een specifiek tijdslot, of helemaal niet mogelijk zijn. Dit staat per dag aangegeven in het overzicht hierboven.';
    } else if (heeftGeenAfhalen) {
      scenarioTekst += 'Op drukke dagen is de winkel gewoon open voor bezoek, maar kunnen bestellingen niet worden afgehaald. Dit staat aangegeven in het overzicht hierboven.';
    } else if (heeftBeperktSlot) {
      scenarioTekst += 'Op drukke momenten is afhalen beperkt tot een korter tijdslot dan de openingstijden. Buiten dat venster is de winkel wel open voor bezoek, maar niet voor het ophalen van bestellingen.';
    }

    scenarioTekst = scenarioTekst.trim();

    html += '<p class="wl-drawer__uitleg">' + basisTekst + '</p>';
    if (scenarioTekst) {
      html += '<p class="wl-drawer__uitleg">' + scenarioTekst + '</p>';
    }

    body.innerHTML = html;
  }

  // ——— OPEN / SLUIT ———
  function openDrawer() {
    bouwDrawerBody();
    dialog.showModal();
    triggerBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function sluitDrawer() {
    if (!dialog.open) return;
    dialog.setAttribute('closing', '');
    dialog.addEventListener('animationend', function handler() {
      dialog.removeAttribute('closing');
      dialog.close();
      dialog.removeEventListener('animationend', handler);
      triggerBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }, { once: true });
  }

  triggerBtn.addEventListener('click', function () {
    dialog.open ? sluitDrawer() : openDrawer();
  });
  sluitBtn && sluitBtn.addEventListener('click', sluitDrawer);
  dialog.addEventListener('click', function(e) { if (e.target===dialog) sluitDrawer(); });
  dialog.addEventListener('cancel', function(e) { e.preventDefault(); sluitDrawer(); });
})();

// ——— STATUS LOGICA & OVERIGE HERO JS ———
(function () {

  var statusEl = document.getElementById('wl-status-tekst');
  if (!statusEl || !statusEl.dataset.schema) return;

  var schema, afhalenSchema, nu, dag, uren;

  try {
    schema = JSON.parse(statusEl.dataset.schema);
  } catch (e) { return; }

  try {
    var afhalenRaw = statusEl.dataset.afhalenSchema;
    afhalenSchema = (afhalenRaw && afhalenRaw !== 'null') ? JSON.parse(afhalenRaw) : null;
  } catch (e) { afhalenSchema = null; }

  // ——— FEESTDAGEN & UITZONDERINGEN ———

  // Bereken Paaszondag voor een gegeven jaar (Computus-algoritme)
  function paasZondag(jaar) {
    var a = jaar % 19, b = Math.floor(jaar / 100), c = jaar % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var maand = Math.floor((h + l - 7 * m + 114) / 31);
    var dag   = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(jaar, maand - 1, dag);
  }

  // Voeg N dagen toe aan een datum
  function plusDagen(d, n) {
    var r = new Date(d); r.setDate(r.getDate() + n); return r;
  }

  // Formatteer datum als "YYYY-MM-DD"
  function datumSleutel(d) {
    return d.getFullYear() + '-'
      + String(d.getMonth() + 1).padStart(2, '0') + '-'
      + String(d.getDate()).padStart(2, '0');
  }

  // Bouw feestdagen-map voor dit jaar (en volgend jaar voor dec/jan grens)
  function bouwFeestdagen(jaar) {
    var paas = paasZondag(jaar);
    var map  = {};

    // Winkeltijdenwet verplichte sluitingsdagen
    map[jaar + '-01-01'] = { gesloten: true, naam: 'Nieuwjaarsdag' };
    map[datumSleutel(plusDagen(paas, 1))]  = { gesloten: true, naam: 'Tweede Paasdag' };
    map[datumSleutel(plusDagen(paas, 39))] = { gesloten: true, naam: 'Hemelvaartsdag' };
    map[datumSleutel(plusDagen(paas, 49))] = { gesloten: true, naam: 'Tweede Pinksterdag' };
    // Kerstavond: winkel moet dicht na 19:00 — we kappen sluitingstijd op 19:00
    map[jaar + '-12-24'] = { sluitUiterlijk: '19:00', naam: 'Kerstavond' };
    map[jaar + '-12-25'] = { gesloten: true, naam: 'Eerste Kerstdag' };
    map[jaar + '-12-26'] = { gesloten: true, naam: 'Tweede Kerstdag' };

    return map;
  }

  nu   = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
  var huidigJaar = nu.getFullYear();
  var feestdagen = Object.assign({}, bouwFeestdagen(huidigJaar), bouwFeestdagen(huidigJaar + 1));

  // Verwerk uitzonderingen-metafield (hogere prioriteit dan feestdagen)
  var uitzonderingen = {};
  try {
    var lijst = JSON.parse(statusEl.dataset.uitzonderingen || '[]');
    lijst.forEach(function(u) {
      if (u.van && u.tot) {
        // Expandeer range naar losse datums
        var cursor = new Date(u.van);
        var einde  = new Date(u.tot);
        while (cursor <= einde) {
          var sleutel = datumSleutel(cursor);
          uitzonderingen[sleutel] = { gesloten: u.gesloten, naam: u.naam, open: u.open, sluit: u.sluit };
          cursor.setDate(cursor.getDate() + 1);
        }
      } else if (u.datum) {
        uitzonderingen[u.datum] = u;
      }
    });
  } catch (e) {}

  // Bepaal de effectieve daginfo: pas feestdag/uitzondering toe op vandaag
  function effectieveInfo(datumStr, basisInfo) {
    var uitzondering = uitzonderingen[datumStr] || feestdagen[datumStr];
    if (!uitzondering) return basisInfo;

    if (uitzondering.gesloten) return null; // volledig gesloten

    if (uitzondering.sluitUiterlijk && basisInfo && basisInfo.open) {
      // Kerstavond: kap sluitingstijd
      var effectief = Object.assign({}, basisInfo);
      if (effectief.sluit > uitzondering.sluitUiterlijk) {
        effectief.sluit = uitzondering.sluitUiterlijk;
      }
      return effectief;
    }

    if (uitzondering.open) {
      // Aangepaste openingstijden uit uitzondering
      return { open: uitzondering.open, sluit: uitzondering.sluit };
    }

    return basisInfo;
  }

  dag  = nu.getDay().toString();
  uren = nu.getHours() * 60 + nu.getMinutes();
  var vandaagDatumStr = datumSleutel(nu);

  var dagNamen  = { '0':'zondag','1':'maandag','2':'dinsdag','3':'woensdag','4':'donderdag','5':'vrijdag','6':'zaterdag' };
  var dagAfkort = { '0':'zo','1':'ma','2':'di','3':'wo','4':'do','5':'vr','6':'za' };

  function tMin(t) { var d = t.split(':'); return +d[0] * 60 + +d[1]; }
  function fmt(t)  { var d = t.split(':'); return d[1] === '00' ? d[0] + 'u' : t; }
  function fmtOpen(t)  { var d = t.split(':'); return d[1] === '00' ? d[0] : t; }
  function fmtSluit(t) { var d = t.split(':'); return d[1] === '00' ? d[0] + 'u' : t; }
  function fmtB(o, s)  { return fmtOpen(o) + '\u2013' + fmtSluit(s); }

  function nlSort(a) { return a === 0 ? 7 : a; }

  function dagReeks(dagen) {
    if (!dagen.length) return '';
    var s = dagen.slice().sort(function(a,b){ return nlSort(a)-nlSort(b); });
    if (s.length === 1) return dagNamen[s[0]];
    var aaneengesloten = s.every(function(d,i){ return i===0 || nlSort(d)-nlSort(s[i-1])===1; });
    if (aaneengesloten) return dagAfkort[s[0]] + '\u2013' + dagAfkort[s[s.length-1]];
    return s.map(function(d){ return dagAfkort[d]; }).join(', ');
  }

  // Eerstvolgende open/afhalen-dag, rekening houdend met feestdagen en uitzonderingen
  function eerstvolgend(type) {
    var bronSchema = type === 'afhalen' ? effectiefAfhalenSchema : schema;
    for (var i = 1; i <= 14; i++) {
      var d    = new Date(nu); d.setDate(d.getDate() + i);
      var dStr = datumSleutel(d);
      var dDag = d.getDay().toString();
      var info = effectieveInfo(dStr, bronSchema[dDag]);
      if (type === 'open'    && info && info.open) return { dag: dagNamen[dDag], d: dDag, datum: d, info: info };
      if (type === 'afhalen' && info && info.open) return { dag: dagNamen[dDag], d: dDag, datum: d, slot: info };
    }
    return null;
  }

  function dagLabel(next) {
    // Vergelijk op basis van verschil in kalenderdagen, niet string-match
    // om timezone edge cases te vermijden
    var nuMidnight   = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate());
    var nextMidnight = new Date(next.datum.getFullYear(), next.datum.getMonth(), next.datum.getDate());
    var dagVerschil  = Math.round((nextMidnight - nuMidnight) / 86400000);
    if (dagVerschil === 1) return 'morgen';
    return next.dag;
  }

  // Vandaag — met feestdag/uitzondering override
  var vandaag = effectieveInfo(vandaagDatumStr, schema[dag]);

  // Bepaal of vandaag gesloten is vanwege een feestdag of uitzondering
  var vandaagUitzondering = uitzonderingen[vandaagDatumStr] || feestdagen[vandaagDatumStr];
  var vandaagReden = null;
  if (vandaagUitzondering && vandaagUitzondering.naam) {
    var basisHadOpeningstijden = (schema[dag] && schema[dag].open);
    var basisHadAfhalen = (effectiefAfhalenSchema[dag] && effectiefAfhalenSchema[dag].open);
    var nuAllesGesloten = (!vandaag || !vandaag.open) && (!vandaagAfhalen || !vandaagAfhalen.open);
    if ((basisHadOpeningstijden || basisHadAfhalen) && nuAllesGesloten) {
      vandaagReden = vandaagUitzondering.naam;
    }
  }

  // Afhalen: gebruik afhalen_schema als aanwezig, anders openingstijden als fallback
  var effectiefAfhalenSchema = afhalenSchema || schema;
  var vandaagAfhalen = effectieveInfo(vandaagDatumStr, effectiefAfhalenSchema[dag]);
  var statusTekst = '';
  var statusKlasse = 'wl-status--neutraal';

  var winkelOpen = false;
  var winkelOpenMin = -1, winkelSluitMin = -1;
  var afhaalActief = false;
  var afhaalOpenMin = -1, afhaalSluitMin = -1;

  if (vandaag && vandaag.open) {
    winkelOpenMin  = tMin(vandaag.open);
    winkelSluitMin = tMin(vandaag.sluit);
    winkelOpen = uren >= winkelOpenMin && uren < winkelSluitMin;
  }

  if (vandaagAfhalen && vandaagAfhalen.open) {
    afhaalOpenMin  = tMin(vandaagAfhalen.open);
    afhaalSluitMin = tMin(vandaagAfhalen.sluit);
    afhaalActief = uren >= afhaalOpenMin && uren < afhaalSluitMin;
  }

  // ——— STATUS TEKST LOGICA ———

  if (winkelOpen && afhaalActief) {
    // Beide actief tegelijk
    var afhaalDeel = afhaalSluitMin - uren <= 60
      ? 'Afhalen nog tot ' + fmt(vandaagAfhalen.sluit)
      : 'Afhalen mogelijk tot ' + fmt(vandaagAfhalen.sluit);
    // Voeg openingstijd alleen toe als winkel langer open is dan afhaalvenster
    if (vandaag.sluit !== vandaagAfhalen.sluit) {
      statusTekst  = afhaalDeel + ' \u00B7 Open tot ' + fmt(vandaag.sluit);
    } else {
      statusTekst  = afhaalDeel;
    }
    statusKlasse = 'wl-status--open';

  } else if (winkelOpen && vandaagAfhalen && uren < afhaalOpenMin) {
    // Winkel open, afhalen komt later vandaag
    var winkelRest = winkelSluitMin - uren;
    var winkelDeel = winkelRest <= 60
      ? 'Sluit binnenkort om ' + fmt(vandaag.sluit)
      : 'Open tot ' + fmt(vandaag.sluit);
    statusTekst  = winkelDeel + ' \u00B7 Afhalen vandaag ' + fmtB(vandaagAfhalen.open, vandaagAfhalen.sluit);
    statusKlasse = 'wl-status--open';

  } else if (winkelOpen) {
    // Alleen winkel open
    var rest = winkelSluitMin - uren;
    if (rest <= 60) {
      statusTekst  = 'Sluit binnenkort om ' + fmt(vandaag.sluit);
      statusKlasse = 'wl-status--sluit-snel';
    } else {
      statusTekst  = 'Open tot ' + fmt(vandaag.sluit);
      statusKlasse = 'wl-status--open';
    }

  } else if (afhaalActief) {
    // Alleen afhalen actief
    var rest = afhaalSluitMin - uren;
    statusTekst  = rest <= 60
      ? 'Afhalen nog tot ' + fmt(vandaagAfhalen.sluit)
      : 'Afhalen mogelijk tot ' + fmt(vandaagAfhalen.sluit);
    statusKlasse = 'wl-status--neutraal';

  } else if (vandaagAfhalen && uren < afhaalOpenMin) {
    // Afhalen komt later vandaag, winkel dicht
    statusTekst  = 'Afhalen vandaag van ' + fmtB(vandaagAfhalen.open, vandaagAfhalen.sluit);
    statusKlasse = 'wl-status--neutraal';

  } else if (vandaag && vandaag.open && uren < winkelOpenMin) {
    // Winkel gaat later vandaag open
    statusTekst  = 'Gaat open om ' + fmt(vandaag.open);
    statusKlasse = 'wl-status--neutraal';

  } else {
    // Alles voorbij of vandaag dicht — zoek eerstvolgende moment
    var volgendeAfhalen = eerstvolgend('afhalen');
    var volgendeOpen    = eerstvolgend('open');

    if (volgendeAfhalen && volgendeOpen) {
      var nuMidnight  = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate());
      var afMidnight  = new Date(volgendeAfhalen.datum.getFullYear(), volgendeAfhalen.datum.getMonth(), volgendeAfhalen.datum.getDate());
      var opMidnight  = new Date(volgendeOpen.datum.getFullYear(), volgendeOpen.datum.getMonth(), volgendeOpen.datum.getDate());
      var afDagen = Math.round((afMidnight - nuMidnight) / 86400000);
      var opDagen = Math.round((opMidnight - nuMidnight) / 86400000);
      if (afDagen <= opDagen) {
        statusTekst = dagLabel(volgendeAfhalen) + ' afhalen van ' + fmtB(volgendeAfhalen.slot.open, volgendeAfhalen.slot.sluit);
      } else {
        var label = dagLabel(volgendeOpen);
        statusTekst = (label === 'morgen' ? 'Morgen open om ' : label.charAt(0).toUpperCase() + label.slice(1) + ' open om ') + fmt(volgendeOpen.info.open);
      }
    } else if (volgendeAfhalen) {
      statusTekst = dagLabel(volgendeAfhalen) + ' afhalen van ' + fmtB(volgendeAfhalen.slot.open, volgendeAfhalen.slot.sluit);
    } else if (volgendeOpen) {
      var label = dagLabel(volgendeOpen);
      statusTekst = (label === 'morgen' ? 'Morgen open om ' : label.charAt(0).toUpperCase() + label.slice(1) + ' open om ') + fmt(volgendeOpen.info.open);
    }
    statusKlasse = 'wl-status--neutraal';
  }

  if (statusTekst && vandaagReden) {
    statusTekst = vandaagReden + ' \u00B7 ' + statusTekst;
  } else if (!statusTekst && vandaagReden) {
    statusTekst = vandaagReden;
  }

  if (statusTekst) {
    statusEl.textContent = statusTekst;
    statusEl.classList.add(statusKlasse);
    statusEl.style.display = 'inline';
  }

  // ——— Scroll-container: .page-wrapper is (assets/base.css) alleen vanaf
  // 990px breed de echte scrollcontainer (overflow-y: auto); daaronder
  // scrollt gewoon window/document. .page-wrapper bestaat in de DOM
  // ongeacht breedte, dus een onvoorwaardelijke `.page-wrapper || window`
  // koos 'm ook op mobiel — waar scrollTo() daarop dan niets deed. ———
  var scrollEl = (window.innerWidth >= 990 && document.querySelector('.page-wrapper')) || window;

  // ——— REVIEWS LINK: scroll met correcte marge voor sticky header + anchor bar ———
  // Het reviews_anchor-setting bevat vaak een volledig wrapper-id
  // ("shopify-section-template--<nummer>__blocks_cgTzET"). Het nummer verandert
  // zodra de template opnieuw wordt aangemaakt; alleen de sleutel na "__" is
  // stabiel, dus val terug op een suffix-match.
  function vindSectieElement(id) {
    if (!id) return null;
    var el = document.getElementById(id);
    if (el) return el;
    var i = id.lastIndexOf('__');
    if (i === -1) return null;
    return document.querySelector('.shopify-section[id$="__' + id.slice(i + 2) + '"]');
  }
  var reviewsLink = document.querySelector('.wl-hero__stat--link[href^="#"]');
  if (reviewsLink) {
    reviewsLink.addEventListener('click', function (e) {
      var targetId = reviewsLink.getAttribute('href').slice(1);
      var target   = vindSectieElement(targetId);
      if (!target) return;
      e.preventDefault();
      // scroll-padding-top = wat Horizon instelt voor de sticky Shopify header
      var scrollPadding = parseInt(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      // anchorBar.offsetHeight = hoogte van de anchor bar zelf (altijd stabiel)
      var anchorBar = document.getElementById('wl-anchor-bar');
      var barHeight = anchorBar ? anchorBar.offsetHeight : 0;
      var offset = scrollPadding + barHeight;
      if (scrollEl === window) {
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        var containerTop = scrollEl.getBoundingClientRect().top;
        var top2 = scrollEl.scrollTop + (target.getBoundingClientRect().top - containerTop) - offset;
        scrollEl.scrollTo({ top: top2, behavior: 'smooth' });
      }
    });
  }
  // ——— VOLGEN KNOP ———
  document.querySelectorAll('[data-action="volgen"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.dataset.url
        || 'https://buurtigo.nl/volgen?winkel=' + encodeURIComponent(btn.dataset.vendor || '');
      window.open(url, 'buurtigo-volgen', 'width=480,height=420,left=200,top=100');
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
